
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/pricing",
      function () {
        return require("private-next-pages/platform/pricing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/pricing"])
      });
    }
  